import Vue from 'vue'

Vue.mixin({
	methods: {
		real: str => str.toLocaleString('pt-br', {
			style: 'currency',
			currency: 'BRL'
		}),
		capitalizeFirstLetter: str => str.charAt(0).toUpperCase() + str.slice(1),
		modalTitle: str => {
			let url = window.location.href.split('/')[3]
			return str == 'New' ? url == 'ratings' ? 'Nova' : 'Novo' : 'Editar'
		},
		slugify: str => {
			str = str.replace(/^\s+|\s+$/g, '') // trim
			str = str.toLowerCase()

			// remove accents, swap ñ for n, etc
			var from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;'
			var to = 'aaaaeeeeiiiioooouuuunc------'
			for (var i = 0, l = from.length; i < l; i++) {
				str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
			}

			str = str
				.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
				.replace(/\s+/g, '-') // collapse whitespace and replace by -
				.replace(/-+/g, '-') // collapse dashes

			return str
		},
		color(p) {
			return p >= 80 && p <= 87 ? 'medium' : p >= 88 ? 'dark' : 'light'
		},
		colorLabel(p) {
			return p >= 80 && p <= 87 ? 'Light Blue' : p >= 88 ? 'Deep Blue' : 'Soft Blue'
		}
	}
})
